/* eslint-disable no-unreachable */
/* eslint-disable no-else-return */
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
// form

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Link, Stack, IconButton, InputAdornment, Typography, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { collection, getDocs, query, where } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { FacebookAuthProvider, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth, db, functions } from '../../../firebase.config';
import { UserAuth } from '../../../context/AuthContext';
// components
import Iconify from '../../../components/Iconify';
import { FormProvider, RHFTextField, RHFCheckbox } from '../../../components/hook-form';
import CustomTextField from '../../../components/ui/customTextField';
import LucideIcon from '../../../components/LucideIcon';
import CustomButton from '../../../components/CustomButton';
import { useSnackbar } from '../../../context/snackbarContext';
import { useSnackbarV2 } from '../../../components/ui/customSnackV2';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();
  // const showSnackbar = useSnackbar()
  const showSnackbarV2 = useSnackbarV2()
  const [email, setEmail] = useState('');
  const [error, setError] = useState(false);
  const [resetPass, setResetPass] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [password, setPassword] = useState('');
  const { user, logIn, resetpass, signInWithGoogle, signInWithFacebook } = UserAuth();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect");

  const [showPassword, setShowPassword] = useState(false);

  const LoginSchema = !resetPass ? Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    password: Yup.string().required('Password is required'),
  }) : Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
  });


  const defaultValues = {
    email: '',
    password: '',
    remember: true,
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });


  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (e) => {
    console.log(e.email);
    
    
    try {
      await logIn(e.email, e.password);
      setError(false);
      if (redirect) {
        showSnackbarV2('Connexion reuissite', 'success')
        navigate(redirect, { replace: true });
        return;
      } else {
        showSnackbarV2('Connexion reuissite', 'success')
        navigate('/bo', { replace: true });
        return;
      }

    } catch (error) {
      console.log(error);
      showSnackbarV2('Email / Mot de passe erroné', 'error')
      setError(true);
    }
  };
  const handleLoginGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Optionnel : créer le profil s’il n’existe pas déjà (dans Firestore)

      // ✅ Redirection après succès
      if (redirect) {
        navigate(redirect, { replace: true });
      } else {
        navigate('/bo', { replace: true });
      }
    } catch (error) {
      console.error('Erreur Google:', error);
      // afficher une alerte si besoin
    }
  };

  const handleLoginFacebook = async () => {
    const provider = new FacebookAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Optionnel : création profil
      console.log(user)
      if (redirect) {
        navigate(redirect, { replace: true });
      } else {
        navigate('/bo', { replace: true });
      }
    } catch (error) {
      console.error('Erreur Facebook:', error);
    }
  };

  const onEmailSend = async (e) => {
    try {
      // await logIn(e.email, e.password)
      // setLoading(true);
      // check
      console.log('result')
      const addMessage = httpsCallable(functions, "emailRestOrg");
      const result = await addMessage({ email: e.email });
      console.log(result)
      setEmailSent(true);
    } catch (error) {
      console.log(error);
      setError(true);
    }
  };

  useEffect(() => {
    (async () => {
      try {

        // setLoading(true);
        // verification de l'existance du compte
        /* navigate('/bo', { replace: true }); */
        console.log(user);

      } catch (error) {
        console.log(error);
      } finally {
        // setLoading(false)
      }
    })();
  }, [user]);



  return !resetPass ? (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={2}>
        <Stack spacing={2}>
          <RHFTextField
            name="email"
            label="Email"
            placeholder="ex: contact@choptonticket.com"
            startIcon={<LucideIcon name="Mail" />}
          />
          <RHFTextField
            label="Mot de passe"
            name="password"
            type={showPassword ? 'text' : 'password'}
            startIcon={<LucideIcon name="Lock" />}
            endIcon={<IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
              <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
            </IconButton>}

          />
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="space-between" >
          <RHFCheckbox name="remember" label="Remember me" />
          <Link underline="hover" onClick={() => setResetPass(true)}>
            <Typography fontSize={16} sx={{ color: '#5E17EB' }}>Mot de passe oublié ?</Typography>

          </Link>
        </Stack>
        {error && (
          <Alert severity="error">
            Email / Mot de passe erroné
          </Alert>
        )}


        <Stack spacing={2}>
          <LoadingButton
            sx={{
              textTransform: 'initial',
              border: '2px solid transparent',
              color: 'white',
              paddingLeft: 5,
              paddingRight: 5,
              backgroundColor: '#5E17EB',
              borderRadius: '7px',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#A47CF4',
                color: 'white',
                borderColor: '#A47CF4',
              },
            }}
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Connexion
          </LoadingButton>
          <Stack direction={'row'} spacing={1}>
            <LoadingButton
              sx={{
                textTransform: 'initial',
                border: '2px solid gainsboro',
                color: '#43424C',
                backgroundColor: 'transparent',
                borderRadius: '7px',
                paddingLeft: 5,
                paddingRight: 5,
                borderColor: '#A9A8B3',
                boxShadow: 0,
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: '#141414',
                  borderColor: '#141414',
                },
              }}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              startIcon={<Iconify icon="logos:google-icon" width={22} />}
              onClick={handleLoginGoogle}
            />

            <LoadingButton
              sx={{
                textTransform: 'initial',
                border: '2px solid gainsboro',
                color: '#43424C',
                backgroundColor: 'transparent',
                borderRadius: '7px',
                paddingLeft: 5,
                paddingRight: 5,
                borderColor: '#A9A8B3',
                boxShadow: 0,
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: '#141414',
                  borderColor: '#141414',
                },
              }}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              startIcon={<Iconify icon="logos:facebook" width={22} />}
              onClick={handleLoginFacebook}
            />

          </Stack>

        </Stack>
      </Stack>


    </FormProvider>
  ) : (
    <FormProvider methods={methods} onSubmit={handleSubmit(onEmailSend)}>
      <Stack spacing={3} paddingY={2}>
        
        {emailSent ? (
          <Typography fontSize={16} color={'text.secondary'} sx={{ marginY: 2 }} severity="success">
            Vérifiez votre boîte de réception, nous vous avons envoyé un lien de récupération du mot de passe
          </Typography>
        ) : <RHFTextField name="email" label="Email" /> }
        <Stack spacing={2}>
          {
            !emailSent && <LoadingButton
            sx={{
              textTransform: 'initial',
              border: '2px solid transparent',
              color: 'white',
              paddingLeft: 5,
              paddingRight: 5,
              backgroundColor: '#5E17EB',
              borderRadius: '16px',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#A47CF4',
                color: 'white',
                borderColor: '#A47CF4',
              },
            }}
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Envoyer le lien de récupération
          </LoadingButton>
          }
          
          <CustomButton fullWidth onClick={() => setResetPass(false)} type={'secondaire'} buttonText={'Retour à la connexion'} />
        </Stack>
      </Stack>




    </FormProvider>
  );
}
